// base64 => file
import MobileDetect from 'mobile-detect';
export function base64ToFile(dataurl, filename) {
  let arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, {
    type: mime
  })
}

// 判断Android or iOS
export function getClientOS() {
  let client = '';
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
    client = 'IOS';
  } else if (/(Android)/i.test(navigator.userAgent)) { //判断Android
    client = 'Android';
  } else {
    client = 'pc';
  }
  return client;
}

// 判断手机型号
export function getMobile() {
  let device_type = navigator.userAgent; //获取userAgent信息
  // console.log(device_type); //打印到页面
  let md = new MobileDetect(device_type); //初始化mobile-detect
  let os = md.os(); //获取系统
  let brand = md.phone()
  let model = "";
  if (os == "iOS") { //ios系统的处理
    os = md.os();
    model = md.mobile();
  } else if (os == "AndroidOS") { //Android系统的处理
    os = 'Android';
    let sss = device_type.split(";");
    let i = sss.indexOf("Build/");
    if (i > -1) {
      model = sss[i].substring(0, sss[i].indexOf("Build/"));
    }
  }
  return {
    os: os,
    model: model,
    brand: brand
  }
}

export function redux(data, keys) {
  return keys.reduce((main, key) => {
    // 简单判断
    if (!main || typeof main[key] === 'undefined') {
      return null
    }
    return main[key]
  }, data)
}

export function isInApp() {
  const cjUserAgent = window.navigator.userAgent;
  return cjUserAgent.indexOf("HxAxClientCmWebKit") > -1;
}

export function isInAppB() {
  const cjUserAgent = window.navigator.userAgent;
  return cjUserAgent.indexOf("HxAxClientCmWebKit") > -1 && cjUserAgent.indexOf("hxAx_B") > -1;
}

export function isInAppC() {
  const cjUserAgent = window.navigator.userAgent;
  return cjUserAgent.indexOf("HxAxClientCmWebKit") > -1 && cjUserAgent.indexOf("hxAx_C") > -1;
}

function compare(curV, reqV){
  if(curV && reqV){
    if (curV === reqV) return true;
     //将两个版本号拆成数字
    var arr1 = curV.split('.'),
        arr2 = reqV.split('.');
    var minLength = Math.min(arr1.length, arr2.length),
        position = 0,
        diff = 0;
     //依次比较版本号每一位大小，当对比得出结果后跳出循环（后文有简单介绍）
    while (position < minLength && ((diff = parseInt(arr1[position]) - parseInt(arr2[position])) == 0)){
      position++;
    }
     diff = (diff != 0) ? diff : (arr1.length - arr2.length);
     // 若curV大于reqV，则返回true
     return diff > 0;
  }else{
     return false;
  }
}
export function isInNewJsBridgeApp() {
  if (isInApp()) {
    const curAppVersion = window.navigator.userAgent.match(/HxAxClientCmWebKit\/(\S*)/)[1];
    // 6.5.35 为 app 切换jsbridge之后的强更版本号
    return compare(curAppVersion, "6.5.35");
  }
  return false;
}
export function judgeAppVersion() { // 因为与app交互的微信方法与实名认证方法最低版本是6.6.00，所以需要判断下
  if (isInApp()) {
    const curAppVersion = window.navigator.userAgent.match(/HxAxClientCmWebKit\/(\S*)/)[1];
    return compare(curAppVersion, "6.6.00");
  }
  return false
}

export function isVersion6770() {
  if (isInApp()) {
    const curAppVersion = window.navigator.userAgent.match(/HxAxClientCmWebKit\/(\S*)/)[1];
    return compare(curAppVersion, "6.7.70");
  }
  return false
}
// yyyy-mm-dd/yyyy-mm => yyyy年mm月dd日/yyyy年mm月
export const gettDateWidthUnit = (str = '') => {
  if (!str) return
  let dateUnit = ['年', '月', '日']
  return String(str).split('-').reduce((res, cur, i) => {
    return  res = res + cur + dateUnit[i]
  }, '')
}
